import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { Box, Icon, Text, TextButton } from '@sparknz/spark-pattern-library';
import { trackCustomLink } from '@sparknz/tracking';

import { getPromotionsByType, PromotionType } from 'shared/utils';
import { useProductDetails } from '../../../../provider';
import { ProductDetailsActionTypes } from '../../../../reducer/productDetails.reducer';
import { InfoLayerStatus } from '../../../../typings';

const IconContainer = styled(Box)`
  width: 24px;
`;

const DealDescription = styled(Text)`
  ${({ theme: { spacing } }) => css`
    width: 100%;
    padding-top: ${spacing.s1};
  `}
`;

const ProductDeals = () => {
  const {
    palette: { baseColors },
  } = useTheme();

  const { dispatch, selectedDevice } = useProductDetails();

  const promoDeals = getPromotionsByType(
    selectedDevice.promotions,
    PromotionType.DEAL,
  );

  return promoDeals?.length ? (
    <Box mb="s2">
      {promoDeals.map((promotion) => (
        <Box
          key={promotion.name}
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          pb="s2"
        >
          <IconContainer flexDirection="row" alignItems="center" mr="s1">
            <Icon name="gift" />
          </IconContainer>
          <Box flexDirection="row">
            <Text variant="bodySMedium" color={baseColors.mawhero}>
              {promotion.shortDescription}
            </Text>
            <TextButton
              title="Gift information icon"
              type="button"
              variant="textbutton"
              onClick={() => {
                dispatch({
                  type: ProductDetailsActionTypes.SetInfoLayer,
                  infoLayer: {
                    contentKey: promotion.contentKey,
                    status: InfoLayerStatus.RawHtml,
                    isNested: false,
                  },
                });
                trackCustomLink('Information icon');
              }}
            >
              <Icon name="info_small" fill={baseColors.lupin} />
            </TextButton>
            {promotion.longDescription ? (
              <DealDescription
                variant="bodySMedium"
                color={baseColors.mawheranui}
              >
                {promotion.longDescription}
              </DealDescription>
            ) : null}
          </Box>
        </Box>
      ))}
    </Box>
  ) : null;
};

export default ProductDeals;
